import { DataInstance } from "./data-instance";
import { JmApi } from "../jm-api/jm-api";

export type OfficeObject = {
  name: string;
  type: string;
  owner: string;
  adress_id: number | undefined;
};

export class Office extends DataInstance {
  public static BASE_URL: string =
    import.meta.env.VITE_CLEVERREACH_API_BASE_URL + "/jmapi/v1/offices";

  private data: OfficeObject;
  private companyId: number | undefined;

  constructor(
    companyId: number | undefined,
    name: string,
    type: string,
    owner: string,
    adress_id: number | undefined = undefined,
  ) {
    super();
    this.companyId = companyId;
    this.data = {
      name: name,
      type: type,
      owner: owner,
      adress_id: adress_id,
    };
  }

  get currentData(): object {
    return this.data;
  }

  get currentId(): number | undefined {
    return this.id;
  }

  static postUrlBuilder(companyId: number) {
    console.log(
      "POST URL Builder: ",
      `${Office.BASE_URL}?CompanyId=${companyId}`,
    );

    return `${Office.BASE_URL}?CompanyId=${companyId}`;
  }

  static getUrlBuilder(
    projectId: number | undefined = undefined,
    companyId: number | undefined = undefined,
  ): string {
    if (companyId && projectId) {
      return `${Office.BASE_URL}?projId=${projectId}&CompanyId=${companyId}`;
    } else if (projectId && !companyId) {
      return `${Office.BASE_URL}?projId=${projectId}`;
    } else if (!projectId && companyId) {
      return `${Office.BASE_URL}?CompanyId=${companyId}`;
    } else if (!projectId && !companyId) {
      return `${Office.BASE_URL}`;
    } else {
      throw new Error("you have to provide either companyId or projectId");
    }
  }

  static putUrlBuilder(officeId: number): string {
    return `${Office.BASE_URL}?OfficeId=${officeId}`;
  }

  static deleteUrlBuilder(officeId: number): string {
    return `${Office.BASE_URL}?OfficeId=${officeId}`;
  }

  async post(chain: boolean = false): Promise<string> {
    return new Promise((resolve, reject) => {
      if (this.companyId) {
        JmApi.post(Office.postUrlBuilder(this.companyId), this.data);
        if (chain) {
          resolve("Standort erfolgreich hinzugefügt");
        }
      } else {
        window.alert(
          "Unternehmen nicht gegeben. Lege, bevor du einen Standort anlegst, ein neues Unternehmen an.",
        );
        throw Error(`companyId or adressId has to be given on Object ${this}`);
      }
    });
  }

  set currentCompany(companyId: number) {
    this.companyId = companyId;
  }

  static fromObject(o: object): Office | null {
    /*
    valid object: {office_name: string, company_id: number, geo?: {coordiantes: [number, number], type: string}, office_id?: number}
    */
    if (o["officeName"]) {
      const result: Office = new Office(
        undefined, // companyId
        o["officeName"],
        o["type"] || "default", // type, default if not provided
        o["owner"] || "", // owner, empty string if not provided
        o["adressId"], // address_id
      );
      if (o["geo"]) {
        result.currentData["geo"] = o["geo"];
      }

      if (o["companyId"]) {
        result.currentCompany = o["companyId"];
      }
      if (!o["officeId"]) {
        return result;
      } else {
        result.id = o["officeId"];
        return result;
      }
    } else {
      return null;
    }
  }
}
